import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { debounceTime, map, Subject, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { MessageError } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class MessageErrorService {
  private http = inject(HttpClient);

  private configUrl = environment.apiUrl;

  public getMoreErrors = new Subject<{limit: number, offset: number, searchQuery: string, type: string}>();

  getLastErrors() {
    const route = `${this.configUrl}w/a/message/lastErrors`;
    return this.getMoreErrors.pipe(
      debounceTime(600),
      switchMap( ({limit, offset, searchQuery, type}) => {
        const params = new HttpParams({
          fromObject: {
            limit: limit.toString(),
            offset: offset.toString(),
            searchQuery,
            type,
          },
        });
        return this.http.get<{rows: MessageError[], count: number}>(route, {params});
      }),
      map((res) => {
        res.rows = res.rows?.map((e) => new MessageError(e));
        return res;
      }),
    );
  }

  retrySendingMessage(messageErrorsIds: number[]) {
    const route = `${this.configUrl}w/a/message/retrySendingMessage`;
    return this.http.post(route, {messageErrorsIds}).pipe();
  }

  updateMessageError(messageToEdit: MessageError) {
    const route = `${this.configUrl}w/a/message/edit`;
    return this.http.put(route, {messageToEdit}).pipe();
  }

  deleteMessageError(messageErrorsIds: number[]) {
    const ids = messageErrorsIds?.filter( (r) => !!r)?.reduce( (acc, r, i) => (`${acc}&ids[${i}]=${r}`), '');
    const route = `${this.configUrl}w/a/message/deleteMessageError?${ids}`;
    return this.http.delete(route).pipe();
  }
}
